import { render } from "./TransactionsList.vue?vue&type=template&id=4f017374&scoped=true"
import script from "./TransactionsList.vue?vue&type=script&lang=js"
export * from "./TransactionsList.vue?vue&type=script&lang=js"

import "./TransactionsList.vue?vue&type=style&index=0&id=4f017374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f017374"]])

export default __exports__